/** WGS84 hash vrcholu sítě segmentů (`adjacent_points`) — jednotná přesnost napříč BE/FE/Android. */

/** Počet desetinných míst lng/lat v klíči adjacentPoints (~1,1 m na šířce). */
export const ADJACENT_POINT_COORD_DECIMALS = 5;

/** Klíč vrcholu: `"lng,lat"` v WGS84. */
export function formatAdjacentPointHash(lng: number, lat: number): string {
  return `${Number(lng).toFixed(ADJACENT_POINT_COORD_DECIMALS)},${Number(lat).toFixed(ADJACENT_POINT_COORD_DECIMALS)}`;
}

/** Parsuje hash vrcholu; vrací null při neplatném formátu. */
export function parseAdjacentPointHash(hash: string): [number, number] | null {
  const parts = hash.split(',');
  if (parts.length !== 2) return null;
  const lng = Number.parseFloat(parts[0]);
  const lat = Number.parseFloat(parts[1]);
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
  return [lng, lat];
}

/** Normalizuje libovolný uložený hash (např. legacy 8 des. míst) na aktuální přesnost. */
export function canonicalAdjacentPointHash(hash: string): string | null {
  const parsed = parseAdjacentPointHash(hash);
  if (!parsed) return null;
  return formatAdjacentPointHash(parsed[0], parsed[1]);
}
